import { render, staticRenderFns } from "./vTour.vue?vue&type=template&id=0af9aee2&scoped=true&"
import script from "./vTour.vue?vue&type=script&lang=js&"
export * from "./vTour.vue?vue&type=script&lang=js&"
import style0 from "./vTour.vue?vue&type=style&index=0&id=0af9aee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af9aee2",
  null
  
)

export default component.exports